import yup, { cardNameValidator, integerNegativeAllowedValidator, booleanValidator } from '~/utils/validators.yup';

export const econ = () =>
    yup.object({
        name: cardNameValidator(),
        speedBuildIncrease: integerNegativeAllowedValidator,
        itemFoundIncrease: integerNegativeAllowedValidator,
        levelUpExperienceReduction: integerNegativeAllowedValidator,
        ingameShopDiscount: integerNegativeAllowedValidator,
        freeBlueprintGranted: integerNegativeAllowedValidator,
        freeKeyGranted: integerNegativeAllowedValidator,
        freeShopRerollGranted: integerNegativeAllowedValidator,
        extraDailyQuestGranted: integerNegativeAllowedValidator,
        extraRankEnergyGranted: integerNegativeAllowedValidator,
        extraShopSlotGranted: integerNegativeAllowedValidator,
        extraRankPointGained: integerNegativeAllowedValidator,
        dailyHpm: integerNegativeAllowedValidator,
        isImmortal: booleanValidator,
        isTireless: booleanValidator,
        rankWonCondition: integerNegativeAllowedValidator,
        rankLostCondition: integerNegativeAllowedValidator,
    });
